import { Helmet } from 'react-helmet';
import { string, number, object, instanceOf, oneOfType } from 'prop-types';

import TopBar from 'components/Header/TopBar/TopBar';
import ScrollTopOnMount from 'components/utility/ScrollTopOnMount/ScrollTopOnMount';
import ErrorContent from 'components/Error/ErrorContent/ErrorContent';
import BackToTop from 'components/BackToTop/BackToTop';
import Footer from 'components/Footer/Footer';

const ErrorPage = ({ error, errorInfo, status }) => {
  const pageTitle = status === 404 ? 'Page not found' : 'Something went wrong';

  return (
    <>
      <ScrollTopOnMount />
      <Helmet defer={false} title={pageTitle} />
      <TopBar />
      <ErrorContent error={error} errorInfo={errorInfo} status={status} />
      <BackToTop />
      <Footer />
    </>
  );
};

ErrorPage.propTypes = {
  /** A status code related to the error, mostly an API/server error status code */
  status: oneOfType([string, number]),
  /** An instance of the native Error object */
  error: instanceOf(Error).isRequired,
  /** An object with additional error information, like a stack trace, or request headers. */
  errorInfo: oneOfType([object, string]),
};

export default ErrorPage;
